<!-- 预览病历 -->
<template>
  <div class="preview">
    <!-- <div class="z-fixed content">
      <div class="fontWeight">该病历是否患者可见</div>
      <a-tooltip placement="top">
        <template #title>
          <span>开启即表示同意患者有权限在患者档案中查看，并生成随访计划进行全病程管理</span>
        </template>
        <auth-img :src="questionImgs" class="questionImgsClass" />
      </a-tooltip>
      <div>
        <a-switch
          v-model:checked="data.patientPermission"
          :checkedValue="data.checkedValue"
          :unCheckedValue="data.unCheckedValue"
          :disabled="formProp.id"
        />
      </div>
    </div> -->
    <!-- 病史信息 -->
    <div class="content fontWeight">
      <div class="chapter" v-if="props.formProp">
        <!-- 添加可见不可见图片-->
        <div class="pChapterImg" v-if="!props.formProp.patientPermission">
          <auth-img mode="ant" height="50px" :src="pInvisibleImg" :preview="false" />
        </div>
        <div class="dChapterImg" v-if="!props.formProp.doctorPermission">
          <auth-img mode="ant" height="50px" :src="dInvisibleImg" :preview="false" />
        </div>
        <div class="dChapterImg" v-if="props?.formProp?.id && !props.formProp.assistPermission">
          <auth-img mode="ant" height="50px" :src="aInvisibleImg" :preview="false" />
        </div>
      </div>
      <!-- <div class="title fontSixteen">病历信息</div> -->
      <a-row type="flex" justify="space-between" :gutter="16">
        <template v-for="(item, index) in data.medicalHistoryList" :key="index">
          <a-col :span="cloSpan(item, index, 0)" v-if="item.isShow && item.key !== 'switchBlock'">
            <div class="contentList" v-if="[10].includes(item.type)">
              <span>{{ item.title }}：</span>
              <span class="value fontColor" v-if="item.key === 'offlineDepartment'">
                {{ props?.formProp[item.key] ? props.formProp[item.key].toString() : '--' }}
              </span>
              <span class="value fontColor" v-if="item.key === 'offlineDiagnosis'">
                <span v-for="(item, index) in props.formProp[item.key]" :key="index">
                  <span v-if="index > 0">；</span>
                  {{ item.label }}
                </span>
              </span>
            </div>
            <div class="contentList" v-else-if="[11].includes(item.type)">
              <span>{{ item.title }}</span>
              <template
                v-if="
                  props.formProp[item.auxiliaryKey] && props.formProp[item.auxiliaryKey].length > 0
                "
              >
                <div class="img-container">
                  <ImageWithName :fileList="props.formProp[item.auxiliaryKey]" />
                </div>
              </template>
              <span class="value fontColor" v-else>：--</span>
            </div>

            <div class="contentList" v-else-if="[12].includes(item.type)">
              <span>{{ item.title }}：</span>
              <template v-if="item.key === 'prescriptionInfo.activityId'">
                <span class="fontColor">{{ activityName(item) }}</span>
              </template>
              <span class="value fontColor" v-if="item.key === 'patientGender'">
                {{
                  props?.formProp[item.key] ? '男' : props.formProp[item.key] === 0 ? '女' : '--'
                }}
              </span>
            </div>

            <div class="contentList" v-else-if="[9].includes(item.type)">
              <span>{{ item.title }}：</span>
              <span
                class="value fontColor"
                v-if="item.key === 'drugInput' || item.key === 'drugCheck'"
              >
                {{ medicationNamesShow() }}
              </span>
            </div>
            <template v-else-if="[13].includes(item.type)">
              <div
                class="contentList"
                v-if="item.key === 'isOpenDrug' && !props.formProp[item.key]"
              >
                <span>处方药品：</span>
                <span class="value fontColor">暂无用药</span>
              </div>
            </template>
            <template v-else-if="[99].includes(item.type)">
              <div
                class="contentList"
                v-if="
                  props.formProp.reserveDate ||
                  props.formProp.reserveDateDetail ||
                  props.formProp.revisitType
                "
              >
                <span>预约复诊：</span>
                <span class="value fontColor retreatSpan">
                  <span v-if="props.formProp.reserveDate">
                    {{ handleTimeShowWeek(props.formProp.reserveDate) }}
                  </span>
                  <span v-if="props.formProp.reserveDateDetail">
                    {{ ['上午', '下午'][props.formProp.reserveDateDetail - 1] }}
                  </span>
                  <span v-if="props.formProp.revisitType">
                    {{ ['线上问诊', '门诊就诊'][props.formProp.revisitType - 1] }}
                  </span>
                </span>
              </div>
            </template>
            <div class="contentList" v-else>
              <span>{{ item.title }}：</span>

              <span class="value fontColor">
                <span v-if="item?.keyOne">
                  {{
                    props?.formProp[item.keyOne] ? props.formProp[item.keyOne][item.keyTwo] : '--'
                  }}
                </span>
                <span v-else>
                  {{ props?.formProp[item.key] ? props.formProp[item.key] : '--' }}
                </span>
              </span>
              <span class="value fontColor">{{ item?.u }}</span>
            </div>
          </a-col>
        </template>
      </a-row>
    </div>
  </div>
</template>
<script setup>
import { defineProps, reactive } from 'vue'
import { medicalHistoryList } from '../hooks/useComponent'
import { trimSpace, handleTimeShowWeek } from '@/utils/index'
import ImageWithName from '@/components/ImageWithName'
const dInvisibleImg = require('@/assets/img/dInvisible.png')
const pInvisibleImg = require('@/assets/img/pInvisible.png')
const aInvisibleImg = require('@/assets/img/aInvisible.png')
const props = defineProps({
  formProp: {
    type: Object,
    default: () => {}
  },
  ypFormProp: {
    type: Object,
    default: () => {}
  }
})
const data = reactive({
  fallbackImg: require('@/assets/img/img-err.png'),
  // patientPermission: 1,
  medicalHistoryDataList: [],
  drugInfoDataList: [],
  checkedValue: 1,
  unCheckedValue: 0,
  medicationNames: '',
  medicalHistoryList: medicalHistoryList
})
// if (sessionStorage.getItem('patientPermission')) {
//   data.patientPermission = Number(sessionStorage.getItem('patientPermission'))
// }
const activityName = item => {
  const { activityId = 0 } = props.formProp?.prescriptionInfo || {}
  if (activityId > 0) {
    const params = item.options.find(n => n.value === activityId)
    return params.label
  } else {
    return '不参与活动'
  }
}
const medicationNamesShow = () => {
  const { activityId = 0 } = props.formProp?.prescriptionInfo || {}
  //多选活动
  if (activityId > 0) {
    const drugCheck = props.formProp.drugCheck
    if (drugCheck && drugCheck[activityId]) {
      return drugCheck ? drugCheck[activityId].join('；') : ''
    }
  } else {
    const drugInput = props.formProp.drugInput.map(item => `${item.name} x${item.amount}`)
    //输入活动
    return drugInput ? drugInput.join('；') : ''
  }
}

changeData('medicalHistoryList', 'formProp', medicalHistoryList)
function changeData(dataListkey, propsKey, list) {
  if (props[propsKey].lengh > 0) {
    const formProp = JSON.parse(JSON.stringify(props[propsKey]))
    for (const key in list) {
      data[dataListkey][key] = formProp[key]
    }
  } else {
    data[dataListkey] = list
  }
}

const cloSpan = (item, index, flg) => {
  if (flg === 0) {
    return [0, 1, 2].includes(index) ? 8 : 24
  } else {
    return 24
  }
}
// watch(
//   () => [data.patientPermission],
//   newValue => {
//     sessionStorage.setItem('patientPermission', Number(newValue[0]))
//   }
// )
</script>
<style scoped lang="scss">
@import './medicalRecordsPoup.scss';
</style>
